<article class="content-container">
  <header>
    @if (isMobile()) {
      <app-toolbar class="sticky">
        <div class="right">
          <app-button (click)="wantsToChangePassword()" icon="mdi mdi-pencil" label="Change password"></app-button>
          <app-button (click)="logout()" label="Logout" icon="mdi mdi-logout"></app-button>
        </div>
      </app-toolbar>
    } @else {
      <div class="toolbar-tweak">
        <app-toolbar>
          <div class="right">
            @if (user.role === 'admin') {
              <app-button label="Fullscreen" (click)="clickFullscreen()" icon="mdi mdi-fullscreen" />
            }
            <app-button (click)="setTheme('dark')" [selected]="currentTheme() === 'dark'"><i class="mdi mdi-moon-waning-crescent mr-1"></i> Dark Mode (orange)</app-button>
            <app-button (click)="setTheme('dark-fourd')" [selected]="currentTheme() === 'dark-fourd'"><i class="mdi mdi-moon-waning-crescent mr-1"></i> Dark Mode (blue)</app-button>
            <app-button (click)="setTheme('light')" [selected]="currentTheme() === 'light'"><i class="mdi mdi-weather-sunny mr-1"></i> Light Mode</app-button>

            <app-button (click)="wantsToChangePassword()" icon="mdi mdi-pencil" label="Change password"></app-button>
            <app-button (click)="logout()" label="Logout" icon="mdi mdi-logout"></app-button>
          </div>
        </app-toolbar>
      </div>
    }
  </header>
  <main>
    <div class="details mt-1 mb-1">
      <div>
        <h5>Name</h5>
        <p>{{ user.name }}</p>
      </div>
      <div>
        <h5>Email address</h5>
        <p>{{ user.email }}</p>
      </div>
    </div>
    @if (user.role === 'admin') {
      <div class="notification-container">
        <div class="mt-1">
          <div>
            <h5>Subscriptions</h5>
            <div class="not-list mt-1">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Notification</th>
                    <th>Description</th>
                    <th>Subscribed</th>
                  </tr>
                </thead>
                <tbody>
                  @for (sub of subscriptionsAvailable; track sub.id) {
                    <tr (click)="notiClick(sub)">
                      <td>{{ sub.title }}</td>
                      <td>{{ sub.description }}</td>
                      <td>{{ sub.isSubscribed === null ? '...' : sub.isSubscribed ? 'Yes' : 'No' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="sites-container">
      <div class="sites mt-1">
        <div>
          <div class="site-card" (click)="link('https://4dmonitoring.co.uk/home-1')">
            <h4 class="text-center">View Our Solutions</h4>
            <!--<img src="https://4dmonitoring.co.uk/home-1" />-->

            <div class="mt-1">
              <app-button label="4D Solutions"></app-button>
            </div>
          </div>
        </div>

        <div>
          <div class="site-card" (click)="link('https://www.4dmonitoring.co.uk/home-1-1')">
            <h4 class="text-center">View Some of Our Sensors</h4>
            <!--            <img src="https://4dmonitoring.co.uk/wp-content/uploads/2020/02/radon-feature-490x300.jpg" alt="projects" /> -->

            <div class="mt-1">
              <app-button label="4D Sensors"></app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="flex-1">
      <div class="feedback">
        @if (wantsToSendFeedback()) {
          <div>
            <h5>Feedback notes</h5>
            <textarea [(ngModel)]="feedbackText"></textarea>
          </div>
          <div>
            <app-button icon="mdi mdi-check" label="Send feedback" (click)="clickFeedback()" />
          </div>
        } @else {
          <app-button icon="mdi mdi-pencil" label="Submit feedback to 4D..." (click)="wantsToSendFeedback.set(true)" />
        }
      </div>
    </div>
  </main>

  @if (isChangingPassword) {
    <app-dialog header="Change password" [hasToolbar]="true" [dimensions]="{ width: 400, height: 220 }" (onClose)="isChangingPassword = null">
      <div class="toolbar">
        <app-toolbar>
          <div class="right">
            <app-button label="Cancel" icon="mdi mdi-close" (click)="isChangingPassword = false" />
            <app-button label="Update" [isCTA]="true" icon="mdi mdi-check" (click)="changePassword()" />
          </div>
        </app-toolbar>
      </div>
      <div class="mt-1">
        <app-data-form [dataForm]="passwordDataFrom" />
      </div>
    </app-dialog>
  }

  @switch (dialogOpen()) {
    @case ('noti') {
      <app-dialog [header]="notiSelected().title" [hasToolbar]="true" [dimensions]="{ width: 550, height: 180 }" (onClose)="dialogOpen.set(null)">
        <div class="mt-1">
          <div class="mb-1">{{ notiSelected().description }}</div>
          @switch (notiSelected().id) {
            <!--
            @case ('billing-reminder') {
              <div class="flex flex-centre">
                <div class="flex-1">{{ notiSelected().valueTitle }}</div>
                <div>
                  <input class="fourd text-right" type="number" [(ngModel)]="notiSelected().value" type="number" />
                </div>
              </div>
            }
            -->
          }
          <div class="flex mt-1">
            <div class="flex-1"></div>
            <div>
              <app-button label="Cancel Subscription" icon="mdi mdi-check" (click)="cancelNoti()" /> &nbsp; <app-button label="Run Subscription now" icon="mdi mdi-play" (click)="runNoti()" /> &nbsp;
              <app-button label="Save" [isCTA]="true" icon="mdi mdi-check" (click)="saveNoti()" />
            </div>
          </div>
        </div>
      </app-dialog>
    }
  }
</article>
